module.exports = __webpack_public_path__ + "img/icon-24-ic-cancel-oval.bb7f4715.svg";